import { Grid } from '@mui/material';
import IbssFormControl from '../../../../Components/Forms/FormControl/IbssFormControl';
import IbssTextField from '../../../../Components/Inputs/TextField/IbssTextField';
import { IbssLuxonDateTimePicker } from '../../../../Components/Inputs/LuxonDateTimePicker/IbssLuxonDateTimePicker';
import { DateTime } from 'luxon';
import { appContext } from '../../../../AppContext';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import RichTextEditor from '../../../../Components/Inputs/RichTextEditor/RichTextEditor';
import { RichTextEditorComponent } from '@syncfusion/ej2-react-richtexteditor';
import { IDropdownOption } from './EditNotification';
import IbssInputDropDown from '../../../../Components/Inputs/SelectList/IbssInputDropDown';
import { SelectChangeEvent } from '@mui/material';
import MediaSelector from '../../../../Components/DialogLaunchers/MediaSelector/MediaSelector';
import { IFile } from '../../../../Providers.Api/Files/FilesRepository';
import DeviceChips from './DeviceChips';

class InspireAnnouncementForm extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    }

    private changeDevices(e: SelectChangeEvent<string | string[]>): void
    {
        const value = e.target.value;
        const selected = (typeof (value) == 'string' ? [value] : value);

        if(selected.length === 0 || (selected[selected.length - 1] === 'All'))
        {
            // if no devices selected, or the last option selected is 'All'
            this.props.onDevicesChanged(['All']);
            return;
        }

        const selectedWithoutAll = selected.filter(option => option !== 'All');
        this.props.onDevicesChanged(selectedWithoutAll);
    }

    private deleteDevice(deviceId: string): void
    {
        const newDeviceIds =  this.props.selectedDeviceIds.filter(id => id !== deviceId );
        if(newDeviceIds.length === 0 || (newDeviceIds[newDeviceIds.length - 1] === 'All'))
        {
            this.props.onDevicesChanged(['All']);
        }
        else
        {
            this.props.onDevicesChanged(newDeviceIds);
        }
    }

    private get selectedDeviceIdsMinusAll(): string[]
    {
        return this.props.selectedDeviceIds.filter(id => id !== 'All');
    }


    public render(): JSX.Element
    {
        return (
            <div style={{ display: 'block' }}>
                <Grid rowSpacing={4} container>
                    <Grid item xs={12}>
                        <div className='mb-1 mt-1 field-heading'>{this.labels.funcAnnouncementsEnterTitleScrollingMessage_L}</div>
                        <Grid item xs={12}>
                            <IbssFormControl sx={{ width: '100%' }}>
                                <IbssTextField
                                    fullWidth
                                    label={this.labels.funcAnnouncementTitle_S}
                                    helperText={`${this.labels.funcAnnouncementCharacterLimit_S}: ${this.props.titleValue.length}/50`}
                                    onChange={(e) => this.props.onTitleChanged(e.target.value)}
                                    value={this.props.titleValue}
                                    inputProps={{ maxLength: 50 }}
                                    error={this.props.showFieldErrors && this.props.titleError}
                                />
                            </IbssFormControl>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <div className='mb-1 field-heading'>{this.labels.OneLens_Announcements_CreateForInspireTextFieldTitle}</div>
                        <RichTextEditor
                            content={this.props.announcementMessage}
                            editorRef={this.props.editorRef}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <div className='mb-1 field-heading'>{this.labels.funcAnnouncementSelectHeaderImage_S}</div>
                        <MediaSelector
                            options={this.props.images.map(x => { return { name: x.name, url: x.path } })}
                            imageSelected={(file: { name: string, url: string }) => this.props.onHeaderImageUrlChanged(file.url)}
                            uploadFile={(filename: string, file: FormData, processAsMap: boolean) => this.props.uploadImage(filename, file, processAsMap)}
                            defaultSelectedImage={this.props.headerImageUrl}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <IbssFormControl sx={{ width: '100%' }} className='mt-1'>
                            <IbssTextField
                                fullWidth
                                label={this.labels.funcAnnouncementsScrollingMessage_L}
                                onChange={(e) => this.props.onScrollingMessageChanged(e.target.value)}
                                value={this.props.scrollingMessage}
                                helperText={`${this.labels.funcAnnouncementCharacterLimit_S}: ${this.props.scrollingMessage.length}/250`}
                                inputProps={{ maxLength: 250 }}
                            />
                        </IbssFormControl>
                    </Grid>
                    <Grid item xs={4} className='mt-1'>
                        <IbssInputDropDown
                            id={'announcement-devices'}
                            inputLabel={this.labels.HubLabelDevices}
                            options={this.props.devices}
                            value={this.props.selectedDeviceIds}
                            isMultiple={true}
                            onChange={(e: SelectChangeEvent<string | string[]>) => this.changeDevices(e)}
                        />
                    </Grid>
                    {
                        this.selectedDeviceIdsMinusAll.length > 0 &&
                        <Grid item xs={12}>
                            <DeviceChips
                                deviceIds={this.selectedDeviceIdsMinusAll}
                                onDelete={(deviceId)=> this.deleteDevice(deviceId)}
                            />
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <hr />
                        <div className='mb-1 field-heading'>{this.labels.funcAnnouncementsMessageSchedule_S}</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'space-between' }}>
                            <IbssFormControl className='mr-3' style={{ width: '49%' }}>
                                <IbssLuxonDateTimePicker
                                    label={this.labels.funcAnnouncementsActiveStart_S}
                                    value={this.props.activeDateTime}
                                    onChange={e => this.props.onActiveDateTimeChanged(e)}
                                    input=
                                    {{
                                        error: this.props.showFieldErrors && this.props.dateTimeFieldError,
                                        helperText: this.props.showFieldErrors && this.props.dateTimeFieldError ? this.labels.funcAnnouncementStartError_Message : ''
                                    }}
                                />
                            </IbssFormControl>
                            <IbssFormControl style={{ width: '49%' }}>
                                <IbssLuxonDateTimePicker
                                    label={this.labels.funcAnnouncementsEndExpire_S}
                                    value={this.props.expireDateTime}
                                    onChange={e => this.props.onExpireDateTimeChanged(e)}
                                    input=
                                    {{
                                        error: this.props.showFieldErrors && this.props.dateTimeFieldError,
                                        helperText: this.props.showFieldErrors && this.props.dateTimeFieldError ? this.labels.funcAnnouncementStartError_Message : ''
                                    }}
                                />
                            </IbssFormControl>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default InspireAnnouncementForm;

export interface IProps
{
    activeDateTime: DateTime;
    onActiveDateTimeChanged: (value: DateTime) => void;
    expireDateTime: DateTime;
    onExpireDateTimeChanged: (value: DateTime) => void;
    onTitleChanged: (value: string) => void;
    titleValue: string;
    onScrollingMessageChanged: (value: string) => void;
    scrollingMessage: string;
    showFieldErrors: boolean;
    titleError: boolean;
    dateTimeFieldError: boolean;
    editorRef: React.RefObject<RichTextEditorComponent>;
    announcementMessage: string;
    devices: IDropdownOption[];
    selectedDeviceIds: string[];
    onDevicesChanged: (deviceIds: string[]) => void;
    headerImageUrl: string;
    images: IFile[];
    onHeaderImageUrlChanged: (url: string) => void;
    uploadImage: (filename: string, file: FormData, processAsMap: boolean) => Promise<void>;
}

export interface IState
{
}